import { simpleFetch } from './customFetch';

export const updateUserAddress = (address) =>
  simpleFetch(
    '/users/self/shipping',
    {
      method: 'PATCH',
      body: JSON.stringify({
        shipAddress1: address.primaryLine,
        shipAddress2: address.secondaryLine,
        shipCity: address.city,
        shipState: address.state,
        shipZipCode: address.zip,
        shipCountry: address.countryCode,
        fffUndeliverable: address.fffUndeliverable,
        lobUndeliverable: address.lobUndeliverable,
      }),
    },
    process.env.REACT_APP_USER_API,
  );
